import { Component, inject, OnInit } from '@angular/core';
import { FiltersFacade } from '@modules/filters/facades';
import { Filter } from '@modules/filters/models';
import { ModalService } from '@core/services';
import { RemoveRecentSelectionDialogComponent } from '../remove-recent-selection-dialog/remove-recent-selection-dialog.component';

@Component({
  standalone: false,
  selector: 'hm-filters-card-list',
  templateUrl: './filters-card-list.component.html',
  styleUrls: ['./filters-card-list.component.scss'],
})
export class FiltersCardListComponent implements OnInit {
  private filtersFacade = inject(FiltersFacade);
  private modalService = inject(ModalService);

  filters$ = this.filtersFacade.filters$;

  ngOnInit(): void {
    this.filtersFacade.loadFilters();
  }

  selectFilter(filter: Filter): void {
    this.filtersFacade.applyFilter(filter);
  }

  removeFilter(filter: Filter): void {
    this.modalService.open(RemoveRecentSelectionDialogComponent, { filter });
  }
}
